export default class OttLabelFilter {

    constructor() {

        this.labels =
            {
                ACSA: {
                    nuevaOtt: 'Nueva OTT',
                    tipoDeObra: 'Tipo de Obra',
                    tipoDispositivo: 'Tipo Dispositivo',
                    fechaOtt: 'Fecha OTT',
                    teams: 'Teams',
                    objetoDeUbicacion: 'Objeto de Ubicacion',
                    listaOtt: 'Listado',
                    porAgendar: 'Ordenes de trabajo Por Agendar',
                    listPre: 'Listado de preincidencias',
                    viewOTT: 'OTT',
                    adminMenuTeams: 'Teams',
                    adminMenuListadoOtt: 'Listado',
                    teamsListado: 'Listado de Teams',
                    teamsNuevo: 'Nuevo Team',
                    equipoNuevo: 'Registrar Equipo',
                    tipoOtt: 'Tipo OTT',
                    equipoLugarOtt: 'Equipo (Lugar)',
                    disponibilidadTeam: 'Disponibilidad Teams',
                    team: 'Team',
                    generarNuevaOtt: "Generar Orden de Trabajo/OTT",
                    verNuevaOtt: "Ver Orden de Trabajo/OTT"
                },
                SCADA: {
                    nuevaOtt: 'Nueva',
                    tipoDeObra: 'Trabajo',
                    tipoDispositivo: 'Tipo de Dispositivo',
                    fechaOtt: 'Fecha',
                    teams: 'Colaboradores',
                    objetoDeUbicacion: 'Ubicacion',
                    listaOtt: 'Agendadas',
                    porAgendar: 'Por Agendar',
                    listPre: 'Preincidencias',
                    viewOTT: 'Orden de Trabajo',
                    adminMenuTeams: 'Colaboradores',
                    adminMenuListadoOtt: 'Agendadas',
                    teamsListado: 'Listado de Colaboradores',
                    teamsNuevo: 'Nuevos Colaboradoes',
                    equipoNuevo: 'Nuevo Equipo',
                    tipoOtt: 'Tipo',
                    equipoLugarOtt: 'Equipo',
                    disponibilidadTeam: 'Disponibilidad Colaboradores',
                    team: "Colaboradores",
                    generarNuevaOtt: "Generar Orden de Trabajo/OTT",
                    verNuevaOtt: "Ver Orden de Trabajo/OTT"
                },
                default: {
                    nuevaOtt: 'Nueva OTT',
                    tipoDeObra: 'Tipo de Obra',
                    tipoDispositivo: 'Tipo Dispositivo',
                    fechaOtt: 'Fecha OTT',
                    teams: 'Teams',
                    objetoDeUbicacion: 'Objeto de Ubicacion',
                    listaOtt: 'Listado',
                    porAgendar: 'Ordenes de trabajo Por Agendar',
                    listPre: 'Listado de preincidencias',
                    viewOTT: 'OTT',
                    adminMenuTeams: 'Teams',
                    adminMenuListadoOtt: 'Listado',
                    teamsListado: 'Listado de Teams',
                    teamsNuevo: 'Nuevo Team',
                    equipoNuevo: 'Registrar Equipo',
                    tipoOtt: 'Tipo OTT',
                    equipoLugarOtt: 'Equipo (Lugar)',
                    disponibilidadTeam: 'Disponibilidad Teams',
                    team: 'Team',
                    generarNuevaOtt: "Generar Orden de Trabajo/OTT",
                    verNuevaOtt: "Ver Orden de Trabajo/OTT"
                }
            }


        return (label, cliente) => {
            console.log(cliente)
            if (this.labels.hasOwnProperty(cliente)) {
                return this.labels[cliente][label] ? this.labels[cliente][label] : label;
            } else {
                return this.labels['default'][label] ? this.labels['default'][label]: label;
            }
        };
    }

    static filter() {
        return new OttLabelFilter();
    }
}



// WEBPACK FOOTER //
// ./app/js/filters/ottLabelFilter.js